import styled from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'

export const FieldInactiveWrapper = styled.div<{ previewMode?: boolean }>`
    padding: 30px;
    display: flex;
    flex-direction: column;
    border-radius: 15px;
    background-color: ${({ theme }) => theme.colors.primaryWhite};
    box-shadow: ${({ previewMode }) => {
        if (!previewMode) {
            return '6px 12px 30px 0px rgba(0, 0, 0, 0.1)'
        }
    }};
    border: ${({ previewMode, theme }) => {
        if (previewMode) {
            return `1px solid ${theme.colors.secondary100Transparent}`
        }
    }};
    position: relative;
    overflow: hidden;
`

export const Header = styled.header`
    margin-bottom: 20px;
`

export const Title = styled.h3`
    margin: 0;
    color: ${({ theme }) => theme.colors.primary90};
    white-space: pre-wrap;

    ${getFontStyle('p01Semibold')}
`

export const OptionsList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 0;
    padding: 0;
    list-style-type: none;
`

export const OptionsListItem = styled.li`
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
    color: ${({ theme }) => theme.colors.primary90};
    white-space: pre-wrap;

    ${getFontStyle('p01Regular')}

    .MuiSvgIcon-root {
        margin-right: 6px;
        width: 20px;
        height: 20px;
        fill: ${({ theme }) => theme.colors.secondary300};
    }
`

export const TextField = styled.div`
    padding-bottom: 4px;
    color: ${({ theme }) => theme.colors.secondary400};
    border-bottom: 1px dotted ${({ theme }) => theme.colors.secondary100Transparent};

    ${getFontStyle('p01Regular')}
`

export const RatingList = styled.ul`
    padding: 0;
    list-style-type: none;
    display: flex;
    justify-content: space-around;
`

export const RatingListItem = styled.li`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
`

export const RatingListItemIndex = styled.span`
    color: ${({ theme }) => theme.colors.secondary400};

    ${getFontStyle('p01Regular')}
`
export const Required = styled.span`
    color: ${({ theme }) => theme.colors.lobsterSharp};

    ${getFontStyle('p03Regular')}
`
